import React, { useRef } from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { Table } from 'antd';
// actions
import therapistsAction from '../../../../../redux/actions/therapists';
// configs
import { columns } from './column';
import useDidMountEffect from '../../../../../configs/hooks/useDidMountEffect';
// types
import { stateType } from '../../../../../types/types';
// style
import './../../style.scss';

const TherapistsTable: React.FC = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const scrollToRef = useRef<any>();

  const loader = useSelector((state: stateType) => state.therapists.loader, shallowEqual);
  const items = useSelector((state: stateType) => state.therapists.items, shallowEqual);
  const params = useSelector((state: stateType) => state.therapists.params, shallowEqual);
  const count = useSelector((state: stateType) => state.therapists.count, shallowEqual);
  const rowI = useSelector((state: stateType) => state.therapists.rowIndex, shallowEqual);

  useDidMountEffect(() => {
    if (items.length && scrollToRef.current) {
      scrollToRef.current.scrollIntoView();
      therapistsAction.rowIndex(undefined);
    }
  }, [loader]);

  return (
    <Table
      rowKey={'id'}
      className="clients-table"
      columns={columns}
      dataSource={loader ? undefined : items}
      loading={loader}
      scroll={{ y: 570 }}
      locale={{ emptyText: <div> </div> }}
      pagination={{
        style: { visibility: `${count <= 10 ? 'hidden' : 'visible'}` },
        size: 'small',
        showQuickJumper: true,
        defaultPageSize: 10,
        pageSize: params.per_page,
        current: params.page,
        total: count,
        pageSizeOptions: ['10', '20', '25', '30', '50', '100'],
        position: ['bottomCenter'],
        onChange: async (page, pageSize) => {
          try {
            await therapistsAction.params({ ...params, page: page, per_page: pageSize });
            dispatch(therapistsAction.get());
          } catch (e) {
            console.log(e);
          }
        },
      }}
      onRow={(record, rowIndex) => {
        return {
          ref: rowIndex === rowI ? scrollToRef : undefined,
          onClick: () => {
            history.push(`/all_therapists/${record.id}`);
            therapistsAction.rowIndex(rowIndex);
          },
        };
      }}
    />
  );
};

export default TherapistsTable;
